<script setup>
import { defineProps, ref, watch } from 'vue';

const props = defineProps({
  img: String,
  body: {
    type: String,
    required: true,
  },
  footer: String,
  buttons: {
    type: Array,
    default: () => [],
  },
});

const handleButtonClick = button => {
  if (button.type === 'URL' && button.url) {
    window.open(button.url, '_blank');
  }
  if (button.type === 'PHONE_NUMBER' && button.phone_number) {
    window.location.href = `tel:${button.phone_number}`;
  }
};

const imagePreview = ref(null);

watch(
  () => props.img,
  img => {
    if (!img) {
      imagePreview.value = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      imagePreview.value = e.target.result;
    };
    reader.readAsDataURL(img);
  },
  { immediate: true }
);
</script>

<template>
  <div class="whatsapp-container">
    <img
      src="assets/images/iphone_template.png"
      alt="iPhone Template"
      class="background"
    />
    <div class="messages">
      <div v-if="imagePreview" class="message-image mb-2">
        <img :src="imagePreview" alt="Message Image" />
      </div>
      <div
        v-if="body"
        class="message sent"
        :class="{ 'has-buttons': buttons.length }"
      >
        <div class="message-content">
          <span v-if="body">{{ body }}</span>
          <span v-if="footer" class="footer">{{ footer }}</span>
        </div>
      </div>
      <div v-if="buttons.length && body">
        <div class="divider" />

        <div
          v-for="(button, index) in buttons"
          :key="index"
          class="whatsapp-button"
          :class="index === buttons.length - 1 ? 'last' : ''"
          @click="handleButtonClick(button)"
        >
          <span class="icon">
            <img
              v-if="button.type === 'URL'"
              src="assets/images/wpp_mock_url_icon.png"
            />
            <img
              v-if="button.type === 'PHONE_NUMBER'"
              src="assets/images/wpp_mock_phone_number_icon.png"
            />
            <img
              v-if="button.type === 'QUICK_REPLY'"
              src="assets/images/wpp_mock_quick_reply_icon.png"
            />
          </span>
          <span class="text">{{ button.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.message {
  min-width: 70%;
  border-radius: 8px;
  position: relative;
  padding: 0;
  overflow: hidden;
}

.message.has-buttons {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.message-content {
  display: flex;
  flex-direction: column;
  padding: 10px;
  padding-bottom: 8px;
}

.divider {
  width: 70%;
  height: 1px;
  background-color: rgb(202, 202, 202);
}

.whatsapp-button {
  width: 70%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-bottom: none;
  padding: 10px 12px;
}
.whatsapp-button.last {
  border-radius: 0 0 8px 8px;
}

.whatsapp-button .text {
  max-width: 75%;
  flex-grow: 1;
  color: #009dff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.whatsapp-button img {
  max-width: none;
  width: 16px;
  height: 16px;
}

.button:first-of-type {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.button:last-of-type {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

/* Keep existing other styles */
.whatsapp-container {
  position: relative;
  width: 375px;
  height: 812px;
}

.background {
  max-width: 300px;
  object-fit: contain;
}

.messages {
  position: absolute;
  top: 90px;
  left: 20px;
  right: 100px;
  bottom: 100px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.message {
  max-width: 70%;
  font-size: 14px;
  background-color: #fff;
  align-self: flex-start;
  color: #111b21;
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.message-image {
  align-self: flex-start;
  max-width: 70%;
}

.message-image img {
  width: 100%;
  border-radius: 10px;
}

.footer {
  max-width: 100%;
  font-size: 12px;
  color: #667781;
  margin-top: 4px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.button:hover {
  background-color: #f5f6f6;
}

.button.quick_reply {
  background-color: #dcf8c6;
  border-color: #d1f7a6;
}
</style>
